/* eslint-disable no-lone-blocks */
import { useSnapshot } from "valtio"
import { chargesBookingValidationStore } from "../mybooksv3/booking-commonstate"
import { cargoStore, configStore, contractsStore, EntityV2Store, loginStore, } from "../state/CommonState";
import { useEffect, useMemo, useState } from "react";
import Utils from "../util/Utils";
import { TableLabel } from "../v3-componets/AgTableLabel"
import chargedetails from "../assets/images/chargedetails.svg";
import { Card } from "../v3-componets/AgCard"
import { Headspan } from "../v3-componets/AgHeadspan"
import { chargesData1 } from "../StaticData";
import QuoteCalcV2 from "../util/quote-calc-v2";
import { editStore } from "./editStore.js";
import { loader } from "../util/loader.js";
import Api from "../state/Api.js";
import { CHARGETYPES, PERMISSIONS_NEW } from "../util/constants.js";
import RoleUtils from "../util/RoleUtils.js";
import TenantUtils from "../util/tenant.utils.js";
import { Controller, FormProvider, useFieldArray, useForm, useFormContext, useWatch } from "react-hook-form";
import { PRICING_CATEGORY } from "../charges_data/LCLCharges.js";
import { TableComboInput } from "../components/AgComponents.js";
import AiChargeParse, { fillChargesForm, AiChargeHistory, loadAiHistory, getAiHistory } from "../components/AiChargeParse";

export default function EditChargenew(props) {
    let setOpenChargeModel = props.setOpenChargeModel
    let routes = props.routes
    useSnapshot(contractsStore)
    useSnapshot(editStore)
    useSnapshot(loginStore)
    // AI charge history of this route: loaded each time the editor opens, saved with the route (save below)
    useEffect(() => { loadAiHistory("quickQuote", Date.now(), editStore.contract?.aiChargeHistory) }, [])
    const [originallist,setOriginallist] = useState([])
    const [originalrebatelist,setOriginalrebatelist] = useState([])
    const [show, setShow] = useState(false)
    const [show1, setShow1] = useState(false)
    const [conditions,setConditions] = useState([])
    const charges = useForm({
        defaultValues:{
            groupedByCategory:{},
            rebate:[],
            pkb:[],
            list:[],
            originallistlist:[],
            originallistrebate:[],
            initialLength:0
        }
    })
    const { control, setValue } = charges;
    
    const watchedList = useWatch({
      control,
      name: 'list',
    });

    const watchedRebate = useWatch({
      control,
      name: 'rebate',
    });

    const watchedPkb = useWatch({
      control,
      name: 'pkb',
    });

    const req = useMemo(() => {
      let limits = []
      let err = []
      let lobj = {}
      let eobj = {}
      let showapprove = false
      if(editStore.contract!=undefined && watchedList!=undefined && watchedPkb!=undefined && watchedRebate!=undefined){
        let l = JSON.parse(JSON.stringify(editStore.contract))
        l['orginalchargesList'] = []
        l['chargesList'] = []
        l['shipperchargesList'] = []
        l['consigneechargesList'] = []
        l['pkb'] = []
        l['rebate'] = []
        if(watchedList.length>0){
          l['orginalchargesList'] = JSON.parse(JSON.stringify(watchedList))
        }
        if(watchedPkb.length>0 && watchedPkb[0]["total"]!=undefined && watchedPkb[0]['total']!=0){
            l['pkb'] = JSON.parse(JSON.stringify(watchedPkb))
            l['pkb'][0]['isIncluded'] = 'Yes'
        }
        if(watchedRebate.length>0 && watchedRebate[0]["total"]!=undefined && watchedRebate[0]['total']!=0){
            l['rebate'] = JSON.parse(JSON.stringify(watchedRebate))
            l['rebate'][0]['isIncluded'] = 'Yes'
        }
        let z = l['orginalchargesList']
        for (let i = 0; i < z.length; i++) {
            if(z[i]['total']!=0){
                z[i]['isIncluded'] = 'Yes'
                if(z[i]['onaccount']=='On Your Account'){
                    l['chargesList'].push(z[i])
                } 
                if(z[i]['onaccount']=="Shipper's Account"){
                    l['shipperchargesList'].push(z[i])
                }
                if(z[i]['onaccount']=="Consignee's Account"){
                    l['consigneechargesList'].push(z[i])
                }
            }
        }
        l['orginalchargesList'] = z
        let k = new QuoteCalcV2(l).recalc()
        l['quoteValue'] = k.quoteValue
        l['quoteValueUSD'] = k.quoteValueUSD
        l['nomrg_chargesList'] = originallist
        l['nomrg_rebate'] = originalrebatelist
        if(k.quoteValue!=0){
            let t1 = Utils.getTotal(originallist)+Utils.getTotal(originalrebatelist)
            let t2 = Utils.getTotal(l['orginalchargesList'])
            let t3 = Utils.getTotal(l['pkb'])
            let t4 = Utils.getTotal(l['rebate'])
            t2 = t2+t4+t3
            conditions.map(e=>{
                if(e.reductionPercentage!=undefined){
                    if(((t2 / t1) * 100) < (100 - e.reductionPercentage)){
                        if(lobj[JSON.stringify(e)]==undefined){
                          lobj[JSON.stringify(e)] = 1
                          limits.push(e)
                        }
                        let e2 = `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${(100 - e.reductionPercentage).toFixed(2)}%).`
                        if(eobj[JSON.stringify(e2)]==undefined){
                          eobj[JSON.stringify(e2)] = 1
                          err.push(e2)
                        }
                    }
                }
                if(e.reductionValue!=undefined){
                  let v = configStore.getExchangeRate(e.reductionValueCurrency)
                  let t5 = t1/v
                  let t6 = t2/v
                  let t7 = t5-e.reductionValue
                  if(t7>t6){
                    let e2 = `Charge list total: ${Utils.N(t5,e.reductionValueCurrency)} (100.00%), Revised list total: ${Utils.N(t6,e.reductionValueCurrency)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${Utils.N(t7,e.reductionValueCurrency)}%).`
                    if(lobj[JSON.stringify(e)]==undefined){
                      lobj[JSON.stringify(e)] = 1
                      limits.push(e)
                    }
                    if(eobj[JSON.stringify(e2)]==undefined){
                      eobj[JSON.stringify(e2)] = 1
                      err.push(e2)
                    }
                  }
                    // l['orginalchargesList'].map(e1=>{
                    //     if(e1['currency']==e.reductionValueCurrency){
                    //         if(e1['total']<e.reductionValue){
                    //             if(lobj[JSON.stringify(e)]==undefined){
                    //               lobj[JSON.stringify(e)] = 1
                    //               limits.push(e)
                    //             }
                    //             let e2 = `${e1['chargeDescription']}, Currency: ${e.reductionValueCurrency}, Totol: ${e1['total']} is less than the allowed limit ${e.reductionValue}`
                    //             if(eobj[JSON.stringify(e2)]==undefined){
                    //               eobj[JSON.stringify(e2)] = 1
                    //               err.push(e2)
                    //             }
                    //         }
                    //     }
                    // })
                }
            })
            if(err.length==0 && t1!=t2 && conditions.length==0){
                err.push(`Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%).`)
            }
            if(err.length>0){
                showapprove = true
            }else{
                showapprove = false
            }
        }
      }

      return { limits, err, showapprove };
    }, [watchedList,watchedPkb,watchedRebate,conditions,originallist]);
    
    useEffect(()=>{
        if(JSON.stringify(contractsStore.current)!=JSON.stringify(editStore.contract)){
            contractsStore.current = JSON.parse(JSON.stringify(editStore.contract))
        }
    },[JSON.stringify(editStore.contract)])

    useEffect(()=>{
        if(editStore.mrg){
let rateType = []
                if(routes[editStore.subscript]['sources']!=undefined){
                    Object.keys(routes[editStore.subscript]['sources']).map(e=>{
                        if(CHARGETYPES[e]!=undefined){
                            rateType.push(CHARGETYPES[e])
                        }else if(e.indexOf('fairterm')!=-1){
                            rateType.push("FT")
                        }else if(e.indexOf('cif')!=-1){
                            rateType.push("CIF")
                        }else{
                            rateType.push(e)
                        }
                    })
                }
                let payload = {
                    pol:Utils.getUNCodeFromLocationString(routes[editStore.subscript]['pol']),
                    pod:Utils.getUNCodeFromLocationString(routes[editStore.subscript]['pod']),
                    fpod:Utils.getUNCodeFromLocationString(routes[editStore.subscript]['fpod']),
                    agent:"",
                    rateType:rateType
                }
                if(routes[editStore.subscript]['agent']!=undefined){
                  payload['agent'] = routes[editStore.subscript]['agent']
                }
                routes[editStore.subscript]['quote']['conditionsPayload'] = payload
                const callback = (data) =>{
                    setConditions(data.data)
                    setShow1(true)
                    loader.hide()
                }
                loader.show()
                Api.apiGetconditionslist(payload,callback)
        }
        
    },[])
    
        const save = async (stage)=>{
        loader.show()
        let limits = []
        let lobj = {}
        let eobj = {}
        let err = []
        if(editStore.contract!=undefined && watchedList!=undefined && watchedPkb!=undefined && watchedRebate!=undefined){
          let l = JSON.parse(JSON.stringify(editStore.contract))
          l["aiChargeHistory"] = getAiHistory("quickQuote")
          chargesBookingValidationStore.isNew = false
          let kz = true
          if (watchedList &&
          !watchedList.every((charge, index) =>
              Object.keys(charge).every((chargeKey) =>
              chargesBookingValidationStore.isValidChargelclform(chargeKey, index,watchedList)
              )
          )
          ) {
          kz = false
          }
          if(!kz){
              configStore.setModalMessage(`Please check the charges detail fields`);
              return false;
          }
          l['orginalchargesList'] = []
          l['chargesList'] = []
          l['shipperchargesList'] = []
          l['consigneechargesList'] = []
          l['pkb'] = []
          l['rebate'] = []
          if(watchedList.length>0){
            l['orginalchargesList'] = JSON.parse(JSON.stringify(watchedList))
          }
          if(watchedPkb.length>0 && watchedPkb[0]["total"]!=undefined && watchedPkb[0]['total']!=0){
              l['pkb'] = JSON.parse(JSON.stringify(watchedPkb))
              l['pkb'][0]['id'] = 1
              l['pkb'][0]['isIncluded'] = 'Yes'
          }
          if(watchedRebate.length>0 && watchedRebate[0]["total"]!=undefined && watchedRebate[0]['total']!=0){
              l['rebate'] = JSON.parse(JSON.stringify(watchedRebate))
              l['rebate'][0]['id'] = 1
              l['rebate'][0]['isIncluded'] = 'Yes'
          }
          let z = l['orginalchargesList']
          for (let i = 0; i < z.length; i++) {
              z[i]['id'] = i+1
              if(z[i]['total']!=0){
                  z[i]['isIncluded'] = 'Yes'
                  if(z[i]['onaccount']=='On Your Account'){
                      l['chargesList'].push(z[i])
                  } 
                  if(z[i]['onaccount']=="Shipper's Account"){
                      l['shipperchargesList'].push(z[i])
                  }
                  if(z[i]['onaccount']=="Consignee's Account"){
                      l['consigneechargesList'].push(z[i])
                  }
              }
          }
          l['orginalchargesList'] = z
          let k = new QuoteCalcV2(l).recalc()
          l['quoteValue'] = k.quoteValue
          l['quoteValueUSD'] = k.quoteValueUSD
          l['nomrg_chargesList'] = originallist
          l['nomrg_rebate'] = originalrebatelist
          editStore.contract = JSON.parse(JSON.stringify(l))
          if(k.quoteValue!=0){
            let t1 = Utils.getTotal(originallist)+Utils.getTotal(originalrebatelist)
            let t2 = Utils.getTotal(l['orginalchargesList'])
            let t3 = Utils.getTotal(l['pkb'])
            let t4 = Utils.getTotal(l['rebate'])
            t2 = t2+t4+t3
            conditions.map(e=>{
                if(e.reductionPercentage!=undefined){
                    if(((t2 / t1) * 100) < (100 - e.reductionPercentage)){
                        if(lobj[JSON.stringify(e)]==undefined){
                          lobj[JSON.stringify(e)] = 1
                          limits.push(e)
                        }
                        let e2 = `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${(100 - e.reductionPercentage).toFixed(2)}%).`
                        if(eobj[JSON.stringify(e2)]==undefined){
                          eobj[JSON.stringify(e2)] = 1
                          err.push(e2)
                        }
                    }
                }
                if(e.reductionValue!=undefined){
                  let v = configStore.getExchangeRate(e.reductionValueCurrency)
                  let t5 = t1/v
                  let t6 = t2/v
                  let t7 = t5-e.reductionValue
                  if(t7>t6){
                    let e2 = `Charge list total: ${Utils.N(t5,e.reductionValueCurrency)} (100.00%), Revised list total: ${Utils.N(t6,e.reductionValueCurrency)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${Utils.N(t7,e.reductionValueCurrency)}%).`
                    if(lobj[JSON.stringify(e)]==undefined){
                      lobj[JSON.stringify(e)] = 1
                      limits.push(e)
                    }
                    if(eobj[JSON.stringify(e2)]==undefined){
                      eobj[JSON.stringify(e2)] = 1
                      err.push(e2)
                    }
                  }
                    // l['orginalchargesList'].map(e1=>{
                    //     if(e1['currency']==e.reductionValueCurrency){
                    //         if(e1['total']<e.reductionValue){
                    //             if(lobj[JSON.stringify(e)]==undefined){
                    //               lobj[JSON.stringify(e)] = 1
                    //               limits.push(e)
                    //             }
                    //             let e2 = `${e1['chargeDescription']}, Currency: ${e.reductionValueCurrency}, Totol: ${e1['total']} is less than the allowed limit ${e.reductionValue}`
                    //             if(eobj[JSON.stringify(e2)]==undefined){
                    //               eobj[JSON.stringify(e2)] = 1
                    //               err.push(e2)
                    //             }
                    //         }
                    //     }
                    // })
                }
            })
            if(err.length==0 && t1!=t2 && conditions.length==0){
                err.push(`Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%).`)
            }
            if(err.length>0){
              l['limitdetails'] = limits
            }
            if(stage=='approve'){
              routes[editStore.subscript]['quote']['totalcharge'] = t1
              routes[editStore.subscript]['quote']['totalrevisedcharge'] = t2
              routes[editStore.subscript]['quote']['limitdetails'] = limits
              routes[editStore.subscript]['quote']['limiterrors'] = err
              routes[editStore.subscript]['quote']['mrg_chargesList'] = l['orginalchargesList']
              routes[editStore.subscript]['quote']['nomrg_chargesList'] = l['nomrg_chargesList']
              routes[editStore.subscript]['quote']['nomrg_rebate'] = l['nomrg_rebate']
              routes[editStore.subscript]['quote']['pkb'] = l['pkb']
              routes[editStore.subscript]['quote']['rebate'] = l['rebate']
              routes[editStore.subscript]['quote']['set'] = routes[editStore.subscript]['set']
              routes[editStore.subscript]['quote']['agent'] = routes[editStore.subscript]['agent']
            }else{
              editStore.contract = JSON.parse(JSON.stringify(l))
              routes[editStore.subscript]['dummyContract'] = JSON.parse(JSON.stringify(l))
            }
            let a = []
            a.push(routes[editStore.subscript])
            editStore.routes = JSON.parse(JSON.stringify(a))
            if(stage=='approve'){
              Api.saveQuoteNoTransform(routes[editStore.subscript],true)
            }
            editStore.savecharge = true
            setOpenChargeModel(false)              
          }else{
              configStore.setModalMessage(`On your account is empty.`);
          }
        }
        loader.hide()
    }
    
    useEffect(()=>{
        if(!show && JSON.stringify(editStore.contract)==JSON.stringify(contractsStore.current)){
          chargesBookingValidationStore.isNew = true
        if(JSON.stringify(cargoStore.cargoList)!=JSON.stringify(editStore.contract.cargoList)){
            cargoStore.cargoList = JSON.parse(JSON.stringify(editStore.contract.cargoList))
        }
        cargoStore.calculateCargoTotals()
        let c = []
        let k = []
        if(editStore.contract.orginalchargesList!=undefined){
            c = editStore.contract.orginalchargesList
        }
        const addchargelist = (chargesList,ch,onaccount) =>{
            let z = chargesList
            for (let i = 0; i < z.length; i++) {
                if(z[i]['isIncluded'] = 'Yes'){
                    z[i]['onaccount'] = onaccount
                    z[i]["id"] = ch.length+1
                    ch.push(z[i])
                }
            }
            return ch
        }
        if(c!=undefined && c.length==0){
            if(editStore.contract.chargesList!=undefined){
                c = addchargelist(editStore.contract.chargesList,c,"On Your Account")
            }
            if(editStore.contract.shipperchargesList!=undefined){
                c = addchargelist(editStore.contract.shipperchargesList,c,"Shipper's Account")
            }
            if(editStore.contract.consigneechargesList!=undefined){
                c = addchargelist(editStore.contract.consigneechargesList,c,"Consignee's Account")
            }
        }
        if(editStore.mrg){
            let type = editStore.contract.shipmentType
            let scope = editStore.contract.shipmentScope
            const data1 = chargesData1[type.toLowerCase()+scope.toLowerCase()];
            if(editStore.contract.rebate==undefined || editStore.contract.rebate.length==0 || Object.keys(editStore.contract.rebate).length==0){
                setValue('rebate',JSON.parse(JSON.stringify(data1.rebate)))
            }else{
                let rebate = editStore.contract.rebate
                if(Utils.isObject(editStore.contract.rebate)){
                  rebate = [editStore.contract.rebate]
                  rebate[0]['category'] = 'REBATE'
                }
                if(rebate[0]['chargeDescription']=='Rebate'){
                  if(editStore.contract.nomrg_rebate!=undefined){
                    if(JSON.stringify(originalrebatelist)!=JSON.stringify(editStore.contract.nomrg_rebate)){
                        setValue('originallistrebate',JSON.parse(JSON.stringify(editStore.contract.nomrg_rebate)))
                        setOriginalrebatelist(JSON.parse(JSON.stringify(editStore.contract.nomrg_rebate)))
                    }
                  }else{
                    setValue('originallistrebate',JSON.parse(JSON.stringify(rebate)))
                    setOriginalrebatelist(JSON.parse(JSON.stringify(rebate)))
                  }
                  setValue('rebate',JSON.parse(JSON.stringify(rebate)))
                }else{
                  setValue('rebate',JSON.parse(JSON.stringify(data1.rebate)))
                }
            }
            if(editStore.contract.pkb==undefined || editStore.contract.pkb.length==0){
                setValue('pkb',JSON.parse(JSON.stringify(data1.pkb)))
            }else{
                let pkb = editStore.contract.pkb
                if(Utils.isObject(editStore.contract.pkb)){
                  pkb = [editStore.contract.pkb]
                  pkb[0]['category'] = 'PKB'
                }
                if(pkb[0]['chargeDescription']=='Freight Commission'){
                  setValue('pkb',JSON.parse(JSON.stringify(pkb)))
                }else{
                  setValue('pkb',JSON.parse(JSON.stringify(data1.pkb)))
                }
            }
            if(editStore.contract.nomrg_chargesList!=undefined){
                k = editStore.contract.nomrg_chargesList
            }
            if(k!=undefined && k.length==0){
                k = c
            }
            if(JSON.stringify(k)!=JSON.stringify(originallist)){
                setValue('initialLength',k.length)
                setValue('originallistlist',k)
                setOriginallist(k)
            }
        }
        
        if(c.length>0){
            let k = JSON.parse(JSON.stringify(c))
            setValue('list',k)
        }
        setShow(true)
        }
    },[JSON.stringify(editStore.contract),JSON.stringify(contractsStore.current)])
    
    const getlcv = (ob,key)=>{
        if(ob!=undefined){
            if(ob[key]!=undefined){
                return ob[key]
            }
        }
        return "-"
    }
    return (<>{ show &&<>
    {
                        (req.err.length>0 && ["krishna.m@agraga.com","krishna.m@navexel.com","satheesh.c@agraga.com","satheesh.c@navexel.com","udayakumar.k@agraga.com","udayakumar.k@navexel.com"].indexOf(loginStore.email)!=-1) && <>
                        <Card>
                                    <Headspan color="#00000" fontSize= "14px" fontWeight="900" data="Charge Limit"/>
                                    {req.limits.length>0 && <div className="table-container">
                                    <table style={{border:"none", width:"100%"}}>
                    <thead>
                        <tr style={{ fontWeight:"900",border:"solid 0.5px #D4D4D4"}}>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Origin Country</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Destination Country</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>POL</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>POD</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Rate Type</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Percentage</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Value</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Value Currency</th>
                        </tr>
                        </thead>
                        <tbody>
                            {
                                req.limits.map(e=>{
                                    return <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"originCountry")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"destinationCountry")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"pol")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"pod")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"rateType")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionPercentage")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionValue")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionValueCurrency")}</td>
                            </tr>
                                })
                            }
                        </tbody>
                        </table>
                        
                        </div>}

                        <div className="table-container">
                                    <table style={{border:"none", width:"100%"}}>
                    
                        <tbody>
                            {
                                req.err.map(e=>{
                                    return <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td style={{color:"#555555", padding:"10px"}}>{e}</td>
                            </tr>
                                })
                            }
                        </tbody>
                        </table>
                        
                        </div>

                                    </Card>
                                    <hr />
                                    
                        </>
                    }
                
{show1 && <><div
                    className="field is-grouped"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    {req.showapprove? <div className="control">
                                <button className="button"
                                 style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                                    onClick={()=>{save('approve')}}>
                                    Request Approve
                                </button>
                            </div>:
                    <div className="control">
                      <button
                        className="button"
                        style={{
                          backgroundColor:
                            process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                          color: "#fff",
                        }}
                        onClick={()=>{save('save')}}
                      >
                        Save
                      </button>
                    </div>}
                    <div className="control">
                      <button
                        class="button is-danger"
                        onClick={() => {
                          setOpenChargeModel(false)
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
   <FormProvider {...charges}>             
<div class="columns is-multiline">
  <div class="column is-4">
    <LCLChargesCompFrom form={charges} listkey={"originallistlist"} oyahide={true} contract={editStore.contract} isDisable={true} heading={"Charge Details"}/>
    {(originalrebatelist.length>0 && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.REBATE)) && <LCLChargesCompFrom form={charges} listkey={"originallistrebate"} hide={true} isDisable={true} contract={editStore.contract}/>}
  </div>
  <div class="column is-8">

    <LCLChargesCompFrom form={charges} listkey={"list"} contract={editStore.contract} heading={"Revised Details"} aiHistory={{ scope: "quickQuote" }} />
        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.REBATE) && <><hr /><LCLChargesCompFrom form={charges} listkey={"rebate"} hide={true} contract={editStore.contract}/></>}
        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.PKB) && <><hr /><LCLChargesCompFrom form={charges} listkey={"pkb"} hide={true} contract={editStore.contract}/></>}

</div>  
</div>   
</FormProvider></>}           
    </>}</>)
}

const CATEGORY_ORDER = ["ORIGIN", "FREIGHT", "DESTINATION"]
const sortCategories = (keys) => [...keys].sort((a, b) => {
  const ia = CATEGORY_ORDER.indexOf(String(a).toUpperCase())
  const ib = CATEGORY_ORDER.indexOf(String(b).toUpperCase())
  return (ia === -1 ? CATEGORY_ORDER.length : ia) - (ib === -1 ? CATEGORY_ORDER.length : ib)
})

export function LCLChargesCompFrom(props) {
  const { listkey, hide, contract, isDisable=false, heading, oyahide, tmptotal,IL, hideAi=false, aiHistory } = props;

  const { control, setValue, getValues } = useFormContext();
  useSnapshot(cargoStore)
  const {
    fields: chargelist,
    append,
    remove,
  } = useFieldArray({
    control,
    name: listkey,
  });
  const onaccount = ["On Your Account", `Consignee's Account`, `Shipper's Account`];

  const watchedCharges = useWatch({
    control,
    name: listkey,
  });

  const initialLength = getValues(IL?IL:"initialLength");

  const totals = useMemo(() => {
    Utils.calculateLCLFormChargesTotals(
      listkey,
      watchedCharges,
      setValue,
      getValues
    );
    let grandTotal = 0,
      shipTotal = 0,
      conTotal = 0,
      volumeDiscount = 0,
      showtotal = false;

    (watchedCharges || []).forEach((e, i) => {
      if (!e) return;
      const rate = configStore.getExchangeRate(e.currency) || 1;
      //   const rate = configStore.getExchangeRateinr(e) || 1;
      if (e.currencyinr == undefined || rate != e.currencyinr) {
        setValue(`${listkey}.${i}.currencyinr`, rate, { shouldDirty: true });
      }

      if (e.chargeDescription === "Volume Discount") {
        let val = Number(tmptotal?e.tmptotal:e.total) || 0;
        if (val > 0) val *= -1;
        volumeDiscount += val * rate;
        return;
      }

      const amount = (Number(tmptotal?e.tmptotal:e.total) || 0) * rate;
      if (e.onaccount?.startsWith("Cons")) conTotal += amount;
      else if (e.onaccount?.startsWith("Ship")) shipTotal += amount;
      else grandTotal += amount;
    });
    if (grandTotal) {
      showtotal = true;
    } else {
      showtotal = false;
    }

    return { grandTotal, shipTotal, conTotal, volumeDiscount, showtotal };
  }, [watchedCharges,cargoStore.totals.totTmpTotalVolume,cargoStore.totals.totTmpTotalWeight]);

  useEffect(() => {
    if(contract!=undefined && Object.keys(contract).length>0){
    let entity = EntityV2Store.list.find(
      (e) => e.entityId === contract.entityId
    );
    if (entity) {
      let sscope = contract.shipmentScope;
      sscope = sscope.toLowerCase();
      let country = "" + entity.entityCountry;
      country = country.toLowerCase();
      let cecisorigin = false;
      let cecisdestination = false;
      let por = ("" + contract.portOfLoading).toLowerCase();
      let pod = ("" + contract.finalPlaceOfDelivery).toLowerCase();
      let q = contract;
      if (
        entity._id == "TBA" &&
        q.isfromAgragaEnquiry != undefined &&
        q.isfromAgragaEnquiry == "Yes" &&
        q.countryFromEnquiry != undefined
      ) {
        country = q.countryFromEnquiry.toLowerCase();
      }
      if (country.includes("hong kong")) {
        cecisorigin = por.includes("hong kong");
        cecisdestination = pod.includes("hong kong");
      } else {
        cecisorigin = por.includes(country);
        cecisdestination = pod.includes(country);
      }
      if (chargelist != undefined) {
        let l = JSON.parse(JSON.stringify(chargelist));
        l.map((e, i) => {
          if (
            sscope.length != 0 &&
            country.length != 0 &&
            por.length != 0 &&
            pod.length != 0
          ) {
            if (e.onaccount != undefined) {
              if (onaccount.indexOf(e.onaccount) == -1) {
                setValue(`${listkey}.${i}.onaccount`, "On Your Account");
              }
            }
          }
          return e;
        });
      }}
    }
  }, [contract, JSON.stringify(watchedCharges)]);
  const addRow = (index,category) =>
    append({
      id: index + 1,
      chargeDescription: listkey=='pkb'?"Freight Commission":"",
      currency: "INR",
      onaccount: "On Your Account",
      category:category,
      perCBM: 0,
      perTon: 0,
      minimum:0,
      maximum:0,
      perShipment: 0,
      total: 0,
    });
  const deleteRow = (index,index2,category) => {
    if(initialLength>index){
      setValue(IL?IL:"initialLength", initialLength-1);
    }
    remove(index);
    if (index2 == 1) {
      append({
        id: index + 1,
        chargeDescription: listkey=='pkb'?"Freight Commission":"",
        currency: "INR",
        onaccount: "On Your Account",
        category:category,
        perCBM: 0,
        perTon: 0,
        minimum:0,
        maximum:0,
        perShipment: 0,
        total: 0,
      });
    }
  };

  const groupedByCategory = useMemo(() => {
    let k = getValues('groupedByCategory')
    let acc = {}
    let k1 = {}
    if(k!=undefined){
      Object.keys(k).map(e=>acc[e]=[])
      let ch = JSON.parse(JSON.stringify(chargelist))
      ch.map((e) => {
          if (e.chargeDescription === 'Volume Discount') return acc;
          const category = e.category || 'FREIGHT';
          if (!acc[category]) acc[category] = [];
          acc[category].push(e);
      }, {})
      setValue('groupedByCategory',acc, { shouldDirty: true })
      // Fixed display order: Origin, Freight, Destination, then anything else
      sortCategories(Object.keys(acc)).map(e=>{if(acc[e].length>0) k1[e]=acc[e]})
    }
    return k1
  }, [chargelist]);


  return (
    <>
    {
      (!isDisable || (isDisable && watchedCharges!=undefined && watchedCharges.length!=0)) && <div style={{
    backgroundColor: "#fff",
    borderRadius: ".25rem",
    boxShadow: "0 .5em 1em -.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02)",
    color: "#4a4a4a",
    maxWidth: "100%",
    position: "relative",
    padding:"1%"
}}>
        {!props.hide && (
          <>
            <Headspan
              color="#00000"
              fontSize="14px"
              fontWeight="900"
              data={` ${heading!=undefined?heading:"Charge Details"}`}
            />
            <AiChargeParse shipmentType="LCL" disabled={hideAi || isDisable || /rebate|pkb/i.test(listkey)} historyScope={aiHistory?.scope} historyKey={listkey} onCharges={(l) => fillChargesForm(getValues, setValue, listkey, l)} />
          </>
        )}
        {aiHistory?.scope && !hideAi && !isDisable && !/rebate|pkb/i.test(listkey) && <AiChargeHistory scope={aiHistory.scope} recordKey={aiHistory.recordKey} initial={aiHistory.initial} chargeKey={listkey} />}
        <div className="table-container m-0 p-0 customchargetable">
          <table className="table is-bordered is-striped is-narrow is-hoverable ">
            <thead>
              <tr >
                {/* {!props.hide && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      
                    }}
                  >
                    ID
                  </th>
                )} */}
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    
                  }}
                >
                  Charge Description
                </th>
                {!props.hide && !oyahide && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      
                    }}
                  >
                    On Account
                  </th>
                )}
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    
                  }}
                >
                  Currency
                </th>
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    
                  }}
                >
                  Per CBM
                </th>
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    
                  }}
                >
                  Per Ton
                </th>
                {!props.hide && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      
                    }}
                  >
                    Minimum
                  </th>
                )}
                {/* {!props.hide && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      
                    }}
                  >
                    Maximum
                  </th>
                )} */}
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    
                  }}
                >
                  Per shipment
                </th>
                {listkey=='pkb' && (
                  <>
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      
                    }}
                  >
                    Update By
                  </th>
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      
                    }}
                  >
                    Update On
                  </th>
                  </>
                )}
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    
                    textAlign: "right",
                  }}
                >
                  Total
                </th>
                {((listkey=='pkb' || !props.hide) && !isDisable) && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      
                    }}
                  >
                    Action
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {Object.entries(groupedByCategory).map(([category, charges]) => {
                let Disable = false
                if(isDisable){
                  Disable = true
                }
                return <>
                <tr>
                    <td colSpan={11}
                        style={{
                          background: "#EAF4FB",
                          
                          color: "#1E4E79",
                        }}>
                      {PRICING_CATEGORY[category]?.label}
                    </td>
                  </tr>
                  {charges.map((e,ind)=>{
                    return <>
                    {chargelist.map((item, index) => {
                {
                  if (item.id != e.id) return <></>;
                  else
                    return (
                      <tr
                        key={item.id}
                        style={{
                          backgroundColor: index % 2 == 1 ? "#F3F3F3" : "none",
                        }}
                      >
                        {/* {!hide && (
                          <td style={{ color: "#555555" }}>
                            {ind + 1}
                          </td>
                        )} */}
                        <td style={{ color: "#555555" }}>
                          {index < initialLength ||
                          item.chargeDescription == "Volume Discount" || hide || Disable ? (
                            <TableLabel
                              record={item}
                              name={"chargeDescription"}
                            />
                          ) : (
                           <Controller
  control={control}
  name={`${listkey}.${index}.chargeDescription`}
  render={({ field: { value, onChange } }) => (
    <TableComboInput
      record={{ chargeDescription: value }}
      name="chargeDescription"
      dataList={configStore
        .getChargeDescriptionList("lcl")
        .filter((val) => val !== "")}
      isValid={chargesBookingValidationStore.isValidChargelclform(
        "chargeDescription",
        index,
        watchedCharges
      )}
      callback={(val) => {
        onChange(val); 
      }}
    />
  )}
/>
                          )}
                        </td>
                        {(!props.hide && !oyahide) && (
                          <td style={{ color: "#555555" }}>
                            {Disable? <TableLabel
                              record={item}
                              name={"onaccount"}
                            />:
                            <Controller
                              control={control}
                              name={`${listkey}.${index}.onaccount`}
                              render={({ field }) => (
                                <div
                                  className={
                                    chargesBookingValidationStore.isValidChargelclform(
                                      "onaccount",
                                      index,
                                      watchedCharges
                                    )
                                      ? "select is-small"
                                      : "select is-small is-danger"
                                  }
                                >
                                  <select {...field} style={{ color: "black" }}>
                                    <option value={""} hidden>
                                      {""}
                                    </option>
                                    {onaccount
                                      .filter((val) => val !== "")
                                      .map((val) => (
                                        <option key={val}>{val}</option>
                                      ))}
                                  </select>
                                </div>
                              )}
                            />}
                          </td>
                        )}
                        <td style={{ color: "#555555" }}>
                          {Disable? <TableLabel
                              record={item}
                              name={"currency"}
                            />:<Controller
                            control={control}
                            name={`${listkey}.${index}.currency`}
                            render={({ field }) => (
                              <div
                                className={
                                  chargesBookingValidationStore.isValidChargelclform(
                                    "currency",
                                    index,
                                    watchedCharges
                                  )
                                    ? "select is-small"
                                    : "select is-small is-danger"
                                }
                              >
                                <select {...field} style={{ color: "black" }} onChange={(e)=>{
                                  setValue(`${listkey}.${index}.currency`,e.target.value,{ shouldDirty: true })
                                  setValue(`${listkey}.${index}.updateby`,loginStore.email,{ shouldDirty: true })
                                  setValue(`${listkey}.${index}.updateon`,Date.now(),{ shouldDirty: true })
                                }}>
                                  <option value={""} hidden>
                                    {""}
                                  </option>
                                  {configStore
                                    .getCurrencyList()
                                    .filter((val) => val !== "")
                                    .map((val) => (
                                      <option key={val}>{val}</option>
                                    ))}
                                </select>
                              </div>
                            )}
                          />}
                        </td>

                        <td
                          style={{
                            color: "#555555",
                            
                            textAlign: "center",
                          }}
                        >
                          {Disable? <TableLabel
                              record={item}
                              name={"perCBM"}
                            />:<Controller
                            control={control}
                            name={`${listkey}.${index}.perCBM`}
                            render={({ field }) => (
                              <div className="control is-fullwidth is-small">
                                <input
                                  {...field}
                                  style={{ color: "black" }}
                                  type="number"
                                  className={
                                    chargesBookingValidationStore.isValidChargelclform(
                                      "perCBM",
                                      index,
                                      watchedCharges
                                    )
                                      ? "input is-small"
                                      : "input is-small is-danger"
                                  }
                                />
                              </div>
                            )}
                          />}
                        </td>
                        <td
                          style={{
                            color: "#555555",
                            
                            textAlign: "center",
                          }}
                        >
                          {Disable? <TableLabel
                              record={item}
                              name={"perTon"}
                            />:<Controller
                            control={control}
                            name={`${listkey}.${index}.perTon`}
                            render={({ field }) => (
                              <div className="control is-fullwidth is-small">
                                <input
                                  {...field}
                                  style={{ color: "black" }}
                                  type="number"
                                  className={
                                    chargesBookingValidationStore.isValidChargelclform(
                                      "perTon",
                                      index,
                                      watchedCharges
                                    )
                                      ? "input is-small"
                                      : "input is-small is-danger"
                                  }
                                />
                              </div>
                            )}
                          />}
                        </td>
                        {!props.hide && (
                          <td
                            style={{
                              color: "#555555",
                              
                              textAlign: "center",
                            }}
                          >
                            {Disable? <TableLabel
                              record={item}
                              name={"minimum"}
                            />:<Controller
                              control={control}
                              name={`${listkey}.${index}.minimum`}
                              render={({ field }) => (
                                <div className="control is-fullwidth is-small">
                                  <input
                                    {...field}
                                    style={{ color: "black" }}
                                    type="number"
                                    className={
                                      chargesBookingValidationStore.isValidChargelclform(
                                        "minimum",
                                        index,
                                        watchedCharges
                                      )
                                        ? "input is-small"
                                        : "input is-small is-danger"
                                    }
                                  />
                                </div>
                              )}
                            />}
                          </td>
                        )}
                        {/* {!props.hide && (
                          <td
                            style={{
                              color: "#555555",
                              
                              textAlign: "center",
                            }}
                          >
                            {Disable? <TableLabel
                              record={item}
                              name={"maximum"}
                            />:<Controller
                              control={control}
                              name={`${listkey}.${index}.maximum`}
                              render={({ field }) => (
                                <div className="control is-fullwidth is-small">
                                  <input
                                    {...field}
                                    style={{ color: "black" }}
                                    type="number"
                                    className={
                                      chargesBookingValidationStore.isValidChargelclform(
                                        "maximum",
                                        index,
                                        watchedCharges
                                      )
                                        ? "input is-small"
                                        : "input is-small is-danger"
                                    }
                                  />
                                </div>
                              )}
                            />}
                          </td>
                        )} */}
                        <td
                          style={{
                            color: "#555555",
                            
                            textAlign: "center",
                          }}
                        >
                          {Disable? <TableLabel
                              record={item}
                              name={"perShipment"}
                            />:<Controller
                            control={control}
                            name={`${listkey}.${index}.perShipment`}
                            render={({ field }) => (
                              <div className="control is-fullwidth is-small">
                                <input
                                  {...field}
                                  style={{ color: "black" }}
                                  type="number"
                                  className={
                                    chargesBookingValidationStore.isValidChargelclform(
                                      "perShipment",
                                      index,
                                      watchedCharges
                                    )
                                      ? "input is-small"
                                      : "input is-small is-danger"
                                  }
                                />
                              </div>
                            )}
                          />}
                        </td>
                        {listkey=='pkb' && (
                  <>
                  <td
                    style={{
                      color: "#555555",
                      
                    }}
                  >
                    {(watchedCharges[index]?.updateby!=undefined)?<>{watchedCharges[index]?.updateby}</>:""}
                  </td>
                  <td
                    style={{
                      color: "#555555",
                      
                    }}
                  >
                    {(watchedCharges[index]?.updateon!=undefined)?<>{Utils.formatToDateTime(Number(watchedCharges[index]?.updateon))}</>:""}
                  </td>
                  </>
                )}
                        <td
                          style={{
                            color: "#555555",
                            
                            textAlign: "right",
                          }}
                        >
                          {Utils.N(
                            tmptotal?watchedCharges[index]?.tmptotal:watchedCharges[index]?.total,
                            watchedCharges[index]?.currency
                          )}
                        </td>

                        {((listkey=='pkb' || !props.hide) && !Disable) && (
                          <td
                            style={{
                              color: "#555555",
                              
                              textAlign: "center",
                            }}
                          >
                            <div className="field has-addons">
                              <p className="control">
                                <button
                                  className="button is-danger is-inverted"
                                  onClick={() => {
                                    deleteRow(index,charges.length,category);
                                  }}
                                >
                                  <span className="icon">
                                    <i className="fas fa-trash"></i>
                                  </span>
                                </button>
                              </p>
                              {ind == charges.length - 1 ? (
                                <p className="control">
                                  <button
                                    className="button is-success is-inverted"
                                    onClick={()=>{addRow(index,category)}}
                                  >
                                    <span className="icon is-small">
                                      <i className="fas fa-plus"></i>
                                    </span>
                                  </button>
                                </p>
                              ) : (
                                ""
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                }
              })}
                    </>
                  })}
              </>
})}
              

              {totals.showtotal ? (
                <>
                  <tr >
                    <td colSpan={(listkey=='pkb' || !props.hide) ? !oyahide? 6 : 5 : 4}></td>
                    <td
                      colSpan={2}
                      style={{
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        
                        textAlign: "right",
                      }}
                    >
                      <strong>{Utils.N(totals.grandTotal)}</strong>
                    </td>
                  </tr>
                  {totals.volumeDiscount != 0 && (
                    <>
                      <tr >
                        <td
                          colSpan={8}
                          style={{
                            textAlign: "right",
                            color: "#555555",
                          }}
                        >
                          Volume Discount :
                        </td>
                        <td
                          colSpan={2}
                          style={{
                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                            
                            textAlign: "right",
                            
                            
                          }}
                        >
                          <strong>{Utils.N(totals.volumeDiscount)}</strong>
                        </td>
                      </tr>
                      <tr >
                        <td
                          colSpan={6}
                          style={{
                            textAlign: "right",
                            color: "#555555",
                            
                            
                          }}
                        >
                          TOTAL :
                        </td>
                        <td
                          colSpan={2}
                          style={{
                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                            
                            textAlign: "right",
                            
                            
                          }}
                        >
                          <strong>
                            {Utils.N(totals.grandTotal + totals.volumeDiscount)}
                          </strong>
                        </td>
                      </tr>
                    </>
                  )}
                  {totals.shipTotal > 0 && (
                    <tr >
                      <td
                        colSpan={!oyahide? 7 : 6}
                        style={{
                          textAlign: "right",
                          color: "#555555",
                          
                          
                        }}
                      >
                        Total of On Shipper's Account :{" "}
                      </td>
                      <td
                        style={{
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          
                          textAlign: "right",
                          
                          
                        }}
                      >
                        <strong>{Utils.N(totals.shipTotal)}</strong>
                      </td>
                    </tr>
                  )}
                  {totals.conTotal > 0 && (
                    <tr >
                      <td
                        colSpan={!oyahide? 7 : 6}
                        style={{
                          textAlign: "right",
                          color: "#555555",
                          
                          
                        }}
                      >
                        Total of On Consignee's Account :{" "}
                      </td>
                      <td
                        style={{
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          
                          textAlign: "right",
                          
                          
                        }}
                      >
                        <strong>{Utils.N(totals.conTotal)}</strong>
                      </td>
                    </tr>
                  )}
                </>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
    </div>
    }
    </>
  );
}


export function LCLChargesCompFromNew(props) {
  const { listkey, hide, contract, hidehr, isDisable=false, hideAi=false, aiHistory } = props;

  const { control, setValue, getValues } = useFormContext();

  const {
    fields: chargelist,
    append,
    remove,
  } = useFieldArray({
    control,
    name: listkey,
  });
  const onaccount = ["On Your Account", `Consignee's Account`, `Shipper's Account`];

  const watchedCharges = useWatch({
    control,
    name: listkey,
  });

  const initialLength = getValues("initialLength");

  const totals = useMemo(() => {
    Utils.calculateLCLFormChargesTotals(
      listkey,
      watchedCharges,
      setValue,
      getValues
    );
    let grandTotal = 0,
      shipTotal = 0,
      conTotal = 0,
      volumeDiscount = 0,
      showtotal = false;

    (watchedCharges || []).forEach((e, i) => {
      if (!e) return;
      const rate = configStore.getExchangeRate(e.currency) || 1;
      //   const rate = configStore.getExchangeRateinr(e) || 1;
      if (e.currencyinr == undefined || rate != e.currencyinr) {
        setValue(`${listkey}.${i}.currencyinr`, rate, { shouldDirty: true });
      }

      if (e.chargeDescription === "Volume Discount") {
        let val = Number(e.total) || 0;
        if (val > 0) val *= -1;
        volumeDiscount += val * rate;
        return;
      }

      const amount = (Number(e.total) || 0) * rate;
      if (e.onaccount?.startsWith("Cons")) conTotal += amount;
      else if (e.onaccount?.startsWith("Ship")) shipTotal += amount;
      else grandTotal += amount;
    });
    if (grandTotal) {
      showtotal = true;
    } else {
      showtotal = false;
    }

    return { grandTotal, shipTotal, conTotal, volumeDiscount, showtotal };
  }, [watchedCharges]);

  useEffect(() => {
    if(contract!=undefined && Object.keys(contract).length>0){
    let entity = EntityV2Store.list.find(
      (e) => e.entityId === contract.entityId
    );
    if (entity) {
      let sscope = contract.shipmentScope;
      sscope = sscope.toLowerCase();
      let country = "" + entity.entityCountry;
      country = country.toLowerCase();
      let cecisorigin = false;
      let cecisdestination = false;
      let por = ("" + contract.portOfLoading).toLowerCase();
      let pod = ("" + contract.finalPlaceOfDelivery).toLowerCase();
      let q = contract;
      if (
        entity._id == "TBA" &&
        q.isfromAgragaEnquiry != undefined &&
        q.isfromAgragaEnquiry == "Yes" &&
        q.countryFromEnquiry != undefined
      ) {
        country = q.countryFromEnquiry.toLowerCase();
      }
      if (country.includes("hong kong")) {
        cecisorigin = por.includes("hong kong");
        cecisdestination = pod.includes("hong kong");
      } else {
        cecisorigin = por.includes(country);
        cecisdestination = pod.includes(country);
      }
      if (chargelist != undefined) {
        let l = JSON.parse(JSON.stringify(chargelist));
        l.map((e, i) => {
          if (
            sscope.length != 0 &&
            country.length != 0 &&
            por.length != 0 &&
            pod.length != 0
          ) {
            if (e.onaccount != undefined) {
              if (onaccount.indexOf(e.onaccount) == -1) {
                setValue(`${listkey}.${i}.onaccount`, "On Your Account");
              }
            }
          }
          return e;
        });
      }}
    }
  }, [contract, JSON.stringify(watchedCharges)]);
  const addRow = (index,category) =>
    append({
      id: index + 1,
      chargeDescription: listkey=='pkb'?"Freight Commission":"",
      currency: "INR",
      onaccount: "On Your Account",
      category:category,
      perCBM: 0,
      perTon: 0,
      minimum:0,
      maximum:0,
      perShipment: 0,
      total: 0,
      isNew:'Y'
    });
  const deleteRow = (index,index2,category) => {
    if(initialLength>index){
      setValue("initialLength", initialLength-1);
    }
    remove(index);
    if (index2 == 1) {
      append({
        id: index + 1,
        chargeDescription: listkey=='pkb'?"Freight Commission":"",
        currency: "INR",
        onaccount: "On Your Account",
        category:category,
        perCBM: 0,
        perTon: 0,
        minimum:0,
        maximum:0,
        perShipment: 0,
        total: 0,
        isNew:'Y'
      });
    }
  };

  const groupedByCategory = useMemo(() => {
    let k = getValues('groupedByCategory')
    let acc = {}
    let k1 = {}
    if(k!=undefined){
      Object.keys(k).map(e=>acc[e]=[])
      let ch = JSON.parse(JSON.stringify(chargelist))
      ch.map((e) => {
          if (e.chargeDescription === 'Volume Discount') return acc;
          const category = e.category || 'FREIGHT';
          if (!acc[category]) acc[category] = [];
          acc[category].push(e);
      }, {})
      setValue('groupedByCategory',acc, { shouldDirty: true })
      // Fixed display order: Origin, Freight, Destination, then anything else
      sortCategories(Object.keys(acc)).map(e=>{if(acc[e].length>0) k1[e]=acc[e]})
    }
    return k1
  }, [chargelist]);

  const checkdiable = (item)=>{
    if(isDisable || item==undefined || (item.chargeDescription!=undefined && item.chargeDescription.length==0) || (item.currency!=undefined && item.currency.length==0)){
      return true
    }else{
      return false
    }
  }



  return (
    <>{
      (!isDisable || (isDisable && watchedCharges!=undefined && watchedCharges.length!=0)) &&<>
      {!hidehr && <hr />}
      <Card>
        {!props.hide && (
          <>
            <span>
              <img src={chargedetails} />
            </span>
            <Headspan
              color="#00000"
              fontSize="14px"
              fontWeight="900"
              data=" Charge Details"
            />
            <AiChargeParse shipmentType="LCL" disabled={hideAi || isDisable || /rebate|pkb/i.test(listkey)} historyScope={aiHistory?.scope} historyKey={listkey} onCharges={(l) => fillChargesForm(getValues, setValue, listkey, l)} />
          </>
        )}
        {aiHistory?.scope && !hideAi && !isDisable && !/rebate|pkb/i.test(listkey) && <AiChargeHistory scope={aiHistory.scope} recordKey={aiHistory.recordKey} initial={aiHistory.initial} chargeKey={listkey} />}
        <div className="table-container">
          <table style={{ border: "none", width: "100%" }}>
            <thead>
              <tr style={{ fontWeight: "900", border: "solid 0.5px #D4D4D4" }}>
                {!props.hide && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      padding: "10px",
                      width: "5rem",
                    }}
                  >
                    ID
                  </th>
                )}
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    padding: "10px",
                    width: "20rem",
                  }}
                >
                  Charge Description
                </th>
                {!props.hide && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      padding: "10px",
                    }}
                  >
                    On Account
                  </th>
                )}
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    padding: "10px",
                  }}
                >
                  Currency
                </th>
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    padding: "10px",
                  }}
                >
                  Per CBM
                </th>
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    padding: "10px",
                  }}
                >
                  Per Ton
                </th>
                {!props.hide && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      padding: "10px",
                    }}
                  >
                    Minimum
                  </th>
                )}
                {!props.hide && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      padding: "10px",
                    }}
                  >
                    Maximum
                  </th>
                )}
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    padding: "10px",
                  }}
                >
                  Per shipment
                </th>
                {listkey=='pkb' && (
                  <>
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      
                    }}
                  >
                    Update By
                  </th>
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      
                    }}
                  >
                    Update On
                  </th>
                  </>
                )}
                <th
                  style={{
                    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    padding: "10px",
                    textAlign: "right",
                  }}
                >
                  Total
                </th>
                {((listkey=='pkb' || !props.hide) && !isDisable) && (
                  <th
                    style={{
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                      padding: "10px",
                    }}
                  >
                    Action
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {Object.entries(groupedByCategory).map(([category, charges]) => {
                let Disable = false
                if(isDisable){
                  Disable = true
                }
                return <>
                <tr>
                    <td colSpan={11}
                        style={{
                          background: "#EAF4FB",
                          fontWeight: 900,
                          padding: "10px",
                          color: "#1E4E79",
                          border: "1px solid #4BA7DD"
                        }}>
                      {PRICING_CATEGORY[category]?.label}
                    </td>
                  </tr>
                  {charges.map((e,ind)=>{
                    return <>
                    {chargelist.map((item, index) => {
                {
                  if (item.id != e.id) return <></>;
                  else
                    return (
                      <tr
                        key={item.id}
                        style={{
                          border: "solid 0.5px #D4D4D4",
                          backgroundColor: index % 2 == 1 ? "#F3F3F3" : "none",
                        }}
                      >
                        {!hide && (
                          <td style={{ color: "#555555", padding: "10px" }}>
                            {ind + 1}
                          </td>
                        )}
                        <td style={{ color: "#555555", padding: "10px" }}>
                          {((item.isNew==undefined || item.isNew!='Y') && index < initialLength) ||
                          item.chargeDescription == "Volume Discount" || hide || Disable ? (
                            <TableLabel
                              record={item}
                              name={"chargeDescription"}
                            />
                          ) : (
                           <Controller
  control={control}
  name={`${listkey}.${index}.chargeDescription`}
  render={({ field: { value, onChange } }) => (
    <TableComboInput
      record={{ chargeDescription: value }} 
      name="chargeDescription"
      dataList={configStore
        .getChargeDescriptionList("lcl")
        .filter((val) => val !== "")}
      isValid={chargesBookingValidationStore.isValidChargelclform(
        "chargeDescription",
        index,
        watchedCharges
      )}
      callback={(val) => {
        onChange(val); 
      }}
    />
  )}
/>
                          )}
                        </td>
                        {!props.hide && (
                          <td style={{ color: "#555555", padding: "10px" }}>
                            {Disable? <TableLabel
                              record={item}
                              name={"onaccount"}
                            />:<Controller
                              control={control}
                              name={`${listkey}.${index}.onaccount`}
                              render={({ field }) => (
                                <div
                                  className={
                                    chargesBookingValidationStore.isValidChargelclform(
                                      "onaccount",
                                      index,
                                      watchedCharges
                                    )
                                      ? "select is-small"
                                      : "select is-small is-danger"
                                  }
                                >
                                  <select {...field} style={{ color: "black" }}>
                                    <option value={""} hidden>
                                      {""}
                                    </option>
                                    {onaccount
                                      .filter((val) => val !== "")
                                      .map((val) => (
                                        <option key={val}>{val}</option>
                                      ))}
                                  </select>
                                </div>
                              )}
                            />}
                          </td>
                        )}
                        <td style={{ color: "#555555", padding: "10px" }}>
                          {Disable? <TableLabel
                              record={item}
                              name={"currency"}
                            />:<Controller
                            control={control}
                            name={`${listkey}.${index}.currency`}
                            render={({ field }) => (
                              <div
                                className={
                                  chargesBookingValidationStore.isValidChargelclform(
                                    "currency",
                                    index,
                                    watchedCharges
                                  )
                                    ? "select is-small"
                                    : "select is-small is-danger"
                                }
                              >
                                <select {...field} style={{ color: "black" }} onChange={(e)=>{
                                  setValue(`${listkey}.${index}.currency`,e.target.value,{ shouldDirty: true })
                                  setValue(`${listkey}.${index}.updateby`,loginStore.email,{ shouldDirty: true })
                                  setValue(`${listkey}.${index}.updateon`,Date.now(),{ shouldDirty: true })
                                }}>
                                  <option value={""} hidden>
                                    {""}
                                  </option>
                                  {configStore
                                    .getCurrencyList()
                                    .filter((val) => val !== "")
                                    .map((val) => (
                                      <option key={val}>{val}</option>
                                    ))}
                                </select>
                              </div>
                            )}
                          />}
                        </td>

                        <td
                          style={{
                            color: "#555555",
                            padding: "10px",
                            textAlign: "center",
                          }}
                        >
                          {checkdiable(watchedCharges[index])? <TableLabel
                              record={item}
                              name={"perCBM"}
                            />:<Controller
                            control={control}
                            name={`${listkey}.${index}.perCBM`}
                            render={({ field }) => (
                              <div className="control is-fullwidth is-small">
                                <input
                                  {...field}
                                  style={{ color: "black" }}
                                  type="number"
                                  className={
                                    (hide || chargesBookingValidationStore.isValidChargelclform(
                                      "perCBM",
                                      index,
                                      watchedCharges
                                    ))
                                      ? "input is-small"
                                      : "input is-small is-danger"
                                  }
                                />
                              </div>
                            )}
                          />}
                        </td>
                        <td
                          style={{
                            color: "#555555",
                            padding: "10px",
                            textAlign: "center",
                          }}
                        >
                          {checkdiable(watchedCharges[index])? <TableLabel
                              record={item}
                              name={"perTon"}
                            />:<Controller
                            control={control}
                            name={`${listkey}.${index}.perTon`}
                            render={({ field }) => (
                              <div className="control is-fullwidth is-small">
                                <input
                                  {...field}
                                  style={{ color: "black" }}
                                  type="number"
                                  className={
                                    (hide || chargesBookingValidationStore.isValidChargelclform(
                                      "perTon",
                                      index,
                                      watchedCharges
                                    ))
                                      ? "input is-small"
                                      : "input is-small is-danger"
                                  }
                                />
                              </div>
                            )}
                          />}
                        </td>
                        {!props.hide && (
                          <td
                            style={{
                              color: "#555555",
                              padding: "10px",
                              textAlign: "center",
                            }}
                          >
                            {checkdiable(watchedCharges[index])? <TableLabel
                              record={item}
                              name={"minimum"}
                            />:<Controller
                              control={control}
                              name={`${listkey}.${index}.minimum`}
                              render={({ field }) => (
                                <div className="control is-fullwidth is-small">
                                  <input
                                    {...field}
                                    style={{ color: "black" }}
                                    type="number"
                                    className={
                                      chargesBookingValidationStore.isValidChargelclform(
                                        "minimum",
                                        index,
                                        watchedCharges
                                      )
                                        ? "input is-small"
                                        : "input is-small is-danger"
                                    }
                                  />
                                </div>
                              )}
                            />}
                          </td>
                        )}
                        {!props.hide && (
                          <td
                            style={{
                              color: "#555555",
                              padding: "10px",
                              textAlign: "center",
                            }}
                          >
                            {checkdiable(watchedCharges[index])? <TableLabel
                              record={item}
                              name={"maximum"}
                            />:<Controller
                              control={control}
                              name={`${listkey}.${index}.maximum`}
                              render={({ field }) => (
                                <div className="control is-fullwidth is-small">
                                  <input
                                    {...field}
                                    style={{ color: "black" }}
                                    type="number"
                                    className={
                                      chargesBookingValidationStore.isValidChargelclform(
                                        "maximum",
                                        index,
                                        watchedCharges
                                      )
                                        ? "input is-small"
                                        : "input is-small is-danger"
                                    }
                                  />
                                </div>
                              )}
                            />}
                          </td>
                        )}
                        <td
                          style={{
                            color: "#555555",
                            padding: "10px",
                            textAlign: "center",
                          }}
                        >
                          {checkdiable(watchedCharges[index])? <TableLabel
                              record={item}
                              name={"perShipment"}
                            />:<Controller
                            control={control}
                            name={`${listkey}.${index}.perShipment`}
                            render={({ field }) => (
                              <div className="control is-fullwidth is-small">
                                <input
                                  {...field}
                                  style={{ color: "black" }}
                                  type="number"
                                  className={
                                    chargesBookingValidationStore.isValidChargelclform(
                                      "perShipment",
                                      index,
                                      watchedCharges
                                    )
                                      ? "input is-small"
                                      : "input is-small is-danger"
                                  }
                                />
                              </div>
                            )}
                          />}
                        </td>
                        {listkey=='pkb' && (
                  <>
                  <td
                    style={{
                      color: "#555555",
                      padding: "10px",
                      
                    }}
                  >
                    {(watchedCharges[index]?.updateby!=undefined)?<>{watchedCharges[index]?.updateby}</>:""}
                  </td>
                  <td
                    style={{
                      color: "#555555",
                      padding: "10px",
                      
                    }}
                  >
                    {(watchedCharges[index]?.updateon!=undefined)?<>{Utils.formatToDateTime(Number(watchedCharges[index]?.updateon))}</>:""}
                  </td>
                  </>
                )}
                        <td
                          style={{
                            color: "#555555",
                            padding: "10px",
                            textAlign: "right",
                          }}
                        >
                          {Utils.N(
                            watchedCharges[index]?.total,
                            watchedCharges[index]?.currency
                          )}
                        </td>

                        {((listkey=='pkb' || !props.hide) && !Disable) && (
                          <td
                            style={{
                              color: "#555555",
                              padding: "10px",
                              textAlign: "center",
                            }}
                          >
                            <div className="field has-addons">
                              <p className="control">
                                <button
                                  className="button is-danger is-inverted"
                                  onClick={() => {
                                    deleteRow(index,charges.length,category);
                                  }}
                                >
                                  <span className="icon">
                                    <i className="fas fa-trash"></i>
                                  </span>
                                </button>
                              </p>
                              {ind == charges.length - 1 ? (
                                <p className="control">
                                  <button
                                    className="button is-success is-inverted"
                                    onClick={()=>{addRow(index,category)}}
                                  >
                                    <span className="icon is-small">
                                      <i className="fas fa-plus"></i>
                                    </span>
                                  </button>
                                </p>
                              ) : (
                                ""
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                }
              })}
                    </>
                  })}
              </>
})}
              

              {totals.showtotal ? (
                <>
                  <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                    <td colSpan={(listkey=='pkb' || !props.hide) ? 8 : 4}></td>
                    <td
                      colSpan={2}
                      style={{
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        padding: "10px",
                        textAlign: "right",
                        fontSize: "1.1rem",
                        fontWeight: "900",
                      }}
                    >
                      <strong>{Utils.N(totals.grandTotal)}</strong>
                    </td>
                  </tr>
                  {totals.volumeDiscount != 0 && (
                    <>
                      <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                        <td
                          colSpan={8}
                          style={{
                            textAlign: "right",
                            color: "#555555",
                            padding: "10px",
                            fontWeight: "900",
                          }}
                        >
                          Volume Discount :
                        </td>
                        <td
                          colSpan={2}
                          style={{
                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                            padding: "10px",
                            textAlign: "right",
                            fontSize: "1.1rem",
                            fontWeight: "900",
                          }}
                        >
                          <strong>{Utils.N(totals.volumeDiscount)}</strong>
                        </td>
                      </tr>
                      <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                        <td
                          colSpan={8}
                          style={{
                            textAlign: "right",
                            color: "#555555",
                            padding: "10px",
                            fontWeight: "900",
                          }}
                        >
                          TOTAL :
                        </td>
                        <td
                          colSpan={2}
                          style={{
                            color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                            padding: "10px",
                            textAlign: "right",
                            fontSize: "1.1rem",
                            fontWeight: "900",
                          }}
                        >
                          <strong>
                            {Utils.N(totals.grandTotal + totals.volumeDiscount)}
                          </strong>
                        </td>
                      </tr>
                    </>
                  )}
                  {totals.shipTotal > 0 && (
                    <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                      <td
                        colSpan={9}
                        style={{
                          textAlign: "right",
                          color: "#555555",
                          padding: "10px",
                          fontWeight: "900",
                        }}
                      >
                        Total of On Shipper's Account :{" "}
                      </td>
                      <td
                        style={{
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          padding: "10px",
                          textAlign: "right",
                          fontSize: "1.1rem",
                          fontWeight: "900",
                        }}
                      >
                        <strong>{Utils.N(totals.shipTotal)}</strong>
                      </td>
                    </tr>
                  )}
                  {totals.conTotal > 0 && (
                    <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                      <td
                        colSpan={9}
                        style={{
                          textAlign: "right",
                          color: "#555555",
                          padding: "10px",
                          fontWeight: "900",
                        }}
                      >
                        Total of On Consignee's Account :{" "}
                      </td>
                      <td
                        style={{
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          padding: "10px",
                          textAlign: "right",
                          fontSize: "1.1rem",
                          fontWeight: "900",
                        }}
                      >
                        <strong>{Utils.N(totals.conTotal)}</strong>
                      </td>
                    </tr>
                  )}
                </>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </>
    }
    </>
  );
}



